"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveSubscription = exports.saveEditSubscription = exports.loadSubscriptions = exports.loadLocations = exports.default = exports.SUBSCRIPTION_REQUEST_PENDING = exports.GET_SUBSCRIPTION = exports.GET_LOCATIONS = exports.EDIT_SUBSCRIPTION = exports.CREATE_SUBSCRIPTION = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/features/array/flat");
var _subscriptionsApi = require("../api/subscriptionsApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var GET_LOCATIONS = exports.GET_LOCATIONS = 'api/reducer/GET_LOCATIONS';
var GET_SUBSCRIPTION = exports.GET_SUBSCRIPTION = 'api/reducer/GET_SUBSCRIPTIONS';
var SUBSCRIPTION_REQUEST_PENDING = exports.SUBSCRIPTION_REQUEST_PENDING = 'api/reducer/SUBSCRIPTION_REQUEST_PENDING';
var CREATE_SUBSCRIPTION = exports.CREATE_SUBSCRIPTION = 'api/reducer/CREATE_SUBSCRIPTION';
var EDIT_SUBSCRIPTION = exports.EDIT_SUBSCRIPTION = 'api/reducer/EDIT_SUBSCRIPTION';
/**
 * check if subscriptions has inactive locations
 * @param subscriptions {array} array of subscription for account
 * @returns {boolean} hasInactiveLocations
 */
var subscriptionsWithInactiveLocations = function subscriptionsWithInactiveLocations(subscriptions) {
  var hasInactiveLocations = subscriptions.map(function (subscription) {
    return subscription.locations.filter(function (location) {
      return !location.active;
    });
  }).flat(Infinity);
  return hasInactiveLocations.length > 0;
};
var loadLocations = exports.loadLocations = function loadLocations(dispatch) {
  (0, _subscriptionsApi.getLocations)().then(function (response) {
    return dispatch({
      type: GET_LOCATIONS,
      data: {
        innerData: response.data.content
      }
    });
  }).catch(function (err) {
    var error = err && err.data && err.data.errors;
    throw error;
  });
};
var loadSubscriptions = exports.loadSubscriptions = function loadSubscriptions(dispatch) {
  (0, _subscriptionsApi.getSubscriptions)().then(function (response) {
    return dispatch({
      type: GET_SUBSCRIPTION,
      data: {
        innerData: response.data.content
      }
    });
  }).catch(function (err) {
    var error = err && err.data && err.data.errors;
    throw error;
  });
};
var saveSubscription = exports.saveSubscription = function saveSubscription(dispatch, payload) {
  dispatch({
    type: SUBSCRIPTION_REQUEST_PENDING
  });
  (0, _subscriptionsApi.createSubscription)(payload).then(function (response) {
    return dispatch({
      type: CREATE_SUBSCRIPTION,
      data: response
    });
  }).catch(function (err) {
    var error = err && err.data && err.data.errors;
    throw error;
  });
};
var saveEditSubscription = exports.saveEditSubscription = function saveEditSubscription(dispatch, subscriptionId, payload) {
  dispatch({
    type: SUBSCRIPTION_REQUEST_PENDING
  });
  (0, _subscriptionsApi.editSubscription)(subscriptionId, payload).then(function (response) {
    return dispatch({
      type: EDIT_SUBSCRIPTION,
      data: response
    });
  }).catch(function (err) {
    var error = err && err.data && err.data.errors;
    throw error;
  });
};
var initialState = {
  isRequestPending: true,
  subscriptions: []
};
var consumptionsReducer = function consumptionsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case GET_LOCATIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        locations: action.data.innerData
      });
    case GET_SUBSCRIPTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        subscriptions: action.data.innerData,
        inactiveLocations: subscriptionsWithInactiveLocations(action.data.innerData),
        isRequestPending: false
      });
    case SUBSCRIPTION_REQUEST_PENDING:
      return _objectSpread(_objectSpread({}, state), {}, {
        isRequestPending: true
      });
    case CREATE_SUBSCRIPTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        isRequestPending: false
      });
    case EDIT_SUBSCRIPTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        isRequestPending: false
      });
    default:
      return state;
  }
};
var _default = exports.default = consumptionsReducer;